import React from 'react';

function DiscussionWidgetSettings({ widgetId }) {

    return null;
}

export default DiscussionWidgetSettings;
